export default __webpack_public_path__ + "static/media/video-1.56df36fa.mp4";